export default "/_next/static/chunks/fonts/S6u9w4BMUTPHh6UVSwaPGR_p-4223b364def982e9d26cce33f074f6c2.woff2";